// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7506d987b5--container--WgklU","image":"_7506d987b5--image--pTMBe","title":"_7506d987b5--title--i0DIb","description":"_7506d987b5--description--ks5Jg"};